<template>
  <div class="app">
    <div v-if="!showIndexPage" style="height: 100%">
      <left-menu v-if="logged" :menus="menus" :autoCollapse="false"></left-menu>
      <login
        v-else
        @success="loginSuccess"
        url="http://keystone.xtooltech.com/signin/login"
        domain="Xtooltech"
        project="922c619ae8ab42f6bc6fddff3eb051e7"
      ></login>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      logged: false
    }
  },
  created() {
    var token = this.$token
    if (token) this.loginSuccess(token)
  },
  computed: {
    menus() {
      var menus = this.$store.getters.menus
      return menus
    },
    showIndexPage() {
      return (
        this.$route.path == '/' ||
        this.$route.path == '/IndexQueryData' ||
        this.$route.path == '/IndexQueryDataEn' ||
        this.$route.path == '/SpecialFunctionQuery'
      )
    }
  },
  methods: {
    loginSuccess(token) {
      // if (!token.res || token.res.length == 0) {
      //   alert('您未开通账号权限')
      //   return
      // }
      this.logged = true
    },
    loginFail(res) {
      if (res.code == 410) {
        alert('您输入的账号不存在')
      } else if (res.code == 411) {
        alert('您输入的密码不正确')
      } else if (res.code == 412) {
        alert('您账号不可用')
      } else if (res.code == 500) {
        alert('未知错误')
      }
    }
  },
  watch: {
    $route: function (to, from) {
      //console.log(this.$route)
      //console.log(to.query.token)
      if (to.query.token) {
        var token = this.$checkToken()
        if (token) this.loginSuccess(token)
      }
    }
  }
}
</script>

<style>
.app {
  height: 100%;
}
</style>
